import React, { useEffect, useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { DataProvider } from './contexts/DataContext';
import { NotificationProvider, useNotifications } from './contexts/NotificationContext';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/LoginPage';
// Modules
import { Dashboard } from './components/modules/Dashboard';
import { Patients } from './components/modules/Patients';
import { Doctors } from './components/modules/Doctors';
import { Appointments } from './components/modules/Appointments';
import { Services } from './components/modules/Services';
import { Insurance } from './components/modules/Insurance';
import { Specialties } from './components/modules/Specialties';
import { Contacts } from './components/modules/Contacts';
import { Companies } from './components/modules/Companies';
import { Leads } from './components/modules/Leads';
import { Opportunities } from './components/modules/Opportunities';
import { Settings } from './components/modules/Settings';
import { ClinicalHistory } from './components/modules/ClinicalHistory';
function AppContent() {
  const {
    isAuthenticated,
    isLoading
  } = useAuth();
  const {
    addNotification
  } = useNotifications();
  const [currentModule, setCurrentModule] = useState('dashboard');
  // Make addNotification available globally for DataContext
  useEffect(() => {
    ;
    (window as any).addNotification = addNotification;
    return () => {
      delete (window as any).addNotification;
    };
  }, [addNotification]);
  if (isLoading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900" data-id="element-0">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-sky-500" data-id="element-1"></div>
      </div>;
  }
  if (!isAuthenticated) {
    return <LoginPage data-id="element-2" />;
  }
  const renderModule = () => {
    switch (currentModule) {
      case 'dashboard':
        return <Dashboard onNavigate={setCurrentModule} data-id="element-3" />;
      case 'patients':
        return <Patients data-id="element-4" />;
      case 'doctors':
        return <Doctors data-id="element-5" />;
      case 'appointments':
        return <Appointments data-id="element-6" />;
      case 'clinical-history':
        return <ClinicalHistory data-id="element-7" />;
      case 'services':
        return <Services data-id="element-8" />;
      case 'insurance':
        return <Insurance data-id="element-9" />;
      case 'specialties':
        return <Specialties data-id="element-10" />;
      case 'contacts':
        return <Contacts data-id="element-11" />;
      case 'companies':
        return <Companies data-id="element-12" />;
      case 'opportunities':
        return <Opportunities data-id="element-13" />;
      case 'settings':
        return <Settings data-id="element-14" />;
      default:
        return <Dashboard onNavigate={setCurrentModule} data-id="element-15" />;
    }
  };
  return <Layout currentModule={currentModule} onModuleChange={setCurrentModule} data-id="element-16">
      {renderModule()}
    </Layout>;
}
export function App() {
  return <ThemeProvider data-id="element-17">
      <AuthProvider data-id="element-18">
        <NotificationProvider data-id="element-19">
          <DataProvider data-id="element-20">
            <AppContent data-id="element-21" />
          </DataProvider>
        </NotificationProvider>
      </AuthProvider>
    </ThemeProvider>;
}